import type { TerminalNotifications } from './workflow-execution-status.interface';

export enum Schedule {
  immediately = 'immediately',
  delayed = 'delayed',
  recurring = 'recurring',
}

export interface UpdateEnqueuedWorkflowExecution<T = object> {
  cron?: string;
  schedule?: Schedule;
  configuration?: T;
  configurationLink?: string;
  running?: boolean;
  executionId?: string;
  /**
   * Replaces wholesale rather than deep-merging — see the `mergeWith` customizer
   * in JobsService.updateWorkflowExecution.
   */
  terminalNotifications?: TerminalNotifications;
}
export interface EnqueuedWorkflowExecution<T = object> {
  id?: number;
  customerId: number;
  workflowName: string;
  cron?: string;
  schedule: Schedule;
  configuration?: T;
  configurationLink?: string;
  running?: boolean;
  executionId?: string;
  correlationId?: string;
  createdByUserId?: number;
  createdByUserEmail?: string;
  additionalJobData?: Record<string, unknown>;
  /**
   * Optional per-job request to be called back on terminal states. Persists
   * across executions, so a recurring job fires its callback on every run.
   */
  terminalNotifications?: TerminalNotifications;
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
}
